import React, { useState, useEffect } from 'react';
import TopBar from '@/Components/TopBar'

const Component = (props: any) => {
  const { mainContent, extra } = props;
  return (
    <TopBar title='工艺设计' mainContent={mainContent} extra={extra} />
  );
};

export default Component;